import { useQuery, UseQueryResult } from "react-query";
import Benefit from "v2/domain/benefits/entities/Benefit";
import findBenefits from "v2/domain/benefits/useCases/findBenefits";
import { QueryKeys } from "v2/ui/hooks/useFindBenefits/QueryKeys";

export default function useFindBenefits({
  companyId,
  benefitModelId,
}: {
  companyId: string;
  benefitModelId: string;
}): UseQueryResult<Benefit[], Error> {
  return useQuery<Benefit[], Error>(
    [QueryKeys.BENEFITS, benefitModelId],
    () => findBenefits({ companyId, benefitModelId }),
    {
      initialData: [],
    }
  );
}
